// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".activityBank_Yubf8sDp{padding:0 calc(50% - 400px);margin-bottom:50px}.activityBank_Yubf8sDp .edit-btn{padding-left:10px !important;padding-right:10px !important}.customToolbar_puK7UsHa{margin:8px 0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"activityBank": "activityBank_Yubf8sDp",
	"customToolbar": "customToolbar_puK7UsHa"
};
export default ___CSS_LOADER_EXPORT___;
